import { combineReducers } from "redux";
import { popUpNotificationReducer, toastNotificationReducer } from "./toastNotificationReducer";


const toastifyReducer = combineReducers({
    toastNotification: toastNotificationReducer,
    popupToastReducer: popUpNotificationReducer
});

export default toastifyReducer;